export const ONE_MORE_QUESTION_CONSTANTS = {
  ROUTES: {
    MAIN: 'one-more-question',
    FORM: 'one-more-question/:venueId',
  },
};
